import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../api/axiosInstance";
const { REACT_APP_API_PATH } = process.env;

export const getVideo = createAsyncThunk(
    "monitor/getVideo",
    async (_, thunkAPI) => {
        try {
            const response = await axiosInstance.get(`${REACT_APP_API_PATH}/monitor/video`)
            const data = response.data
            return {
                video: data.data[0],
            }
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const getSupportInitiative = createAsyncThunk(
    "monitor/getSupportInitiative",
    async (_, thunkAPI) => {
        try {
            const response = await axiosInstance.get(`${REACT_APP_API_PATH}/apoyan-iniciativa`)
            const data = response.data
            return {
                allies: data.data,
            }
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const getDisclaimer = createAsyncThunk(
    "monitor/getDisclaimer",
    async (_, thunkAPI) => {
        try {
            const response = await axiosInstance.get(`${REACT_APP_API_PATH}/monitor/disclaimer`)
            const data = response.data
            return {
                disclaimer: data.data,
            }
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);